/**
 * widgets/registry.rustdesk.tsx — RustDesk (stanice, adresa, server, kontejnery).
 */
import { BookUser, Box, Globe, KeyRound, Monitor, Package, ScrollText, Server, Terminal } from 'lucide-react';
import i18n from '../lib/i18n';
import type { WidgetSpec } from './types';
import { ContainerList } from './registry.docker';
import {
  RustdeskAuditWidget,
  RustdeskBooksWidget,
  RustdeskEngineWidget,
  RustdeskFleetWidget,
  RustdeskLoginWidget,
  RustdeskPublicWidget,
  RustdeskStationsWidget,
} from '../pages/modules/rustdesk/panels';
import { RustdeskPackagesWidget } from '../pages/modules/rustdesk/packages-panel';

export const RUSTDESK_WIDGETS: WidgetSpec[] = [
  {
    id: 'rustdesk.stations',
    title: 'Stanice',
    module: 'rustdesk',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Monitor,
    since: '2.2.0',
    component: RustdeskStationsWidget,
  },
  {
    id: 'rustdesk.books',
    title: i18n.t('rustdesk.tabBooks', 'Adresáře'),
    module: 'rustdesk',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: BookUser,
    since: '2.2.0',
    component: RustdeskBooksWidget,
  },
  {
    id: 'rustdesk.packages',
    title: i18n.t('rustdesk.tabPackages', 'Balíčky'),
    module: 'rustdesk',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Package,
    since: '2.2.0',
    component: RustdeskPackagesWidget,
  },
  {
    id: 'rustdesk.audit',
    title: 'Audit',
    module: 'rustdesk',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: ScrollText,
    since: '2.2.0',
    component: RustdeskAuditWidget,
  },
  {
    id: 'rustdesk.engine',
    title: 'Server',
    module: 'rustdesk',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Server,
    since: '2.2.0',
    component: RustdeskEngineWidget,
  },
  {
    id: 'rustdesk.public',
    title: i18n.t('rustdesk.publicTitle', 'Veřejná adresa'),
    module: 'rustdesk',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Globe,
    since: '2.2.0',
    component: RustdeskPublicWidget,
  },
  {
    id: 'rustdesk.login',
    title: i18n.t('rustdesk.loginTitle', 'Přihlášení'),
    module: 'rustdesk',
    kind: 'custom',
    format: 'md',
    formats: ['md', 'lg'],
    icon: KeyRound,
    since: '2.2.0',
    component: RustdeskLoginWidget,
  },
  {
    id: 'rustdesk.fleet',
    title: 'Fleet',
    module: 'rustdesk',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Terminal,
    since: '2.2.0',
    component: RustdeskFleetWidget,
  },
  {
    id: 'rustdesk.containers',
    title: 'Kontejnery',
    module: 'rustdesk',
    kind: 'custom',
    format: 'lg',
    formats: ['lg'],
    icon: Box,
    since: '2.2.0',
    component: function RustdeskContainersWidget({ scope }) {
      return (
        <ContainerList
          scope={scope}
          moduleFilter='rustdesk'
          controls
          hideWhenEmpty={false}
        />
      );
    },
  },
];
